// extracted by mini-css-extract-plugin
export default {"learning_subjects":"subjects_learning_subjects__9SFC3","subjects_catalogue":"subjects_subjects_catalogue__xP28l","similarH4":"subjects_similarH4__MlaXL"};